import {
    MdDesignServices,
    MdOutlineHistory,
    MdOutlineLocalOffer,
  } from "react-icons/md";
import { LuLayoutDashboard } from "react-icons/lu";
import { HiOutlineRectangleStack } from "react-icons/hi2";
import { AiOutlineMessage, AiOutlineShop } from "react-icons/ai";
import { CiShop } from "react-icons/ci";
import { FaProductHunt } from "react-icons/fa";


export const menu = [
    {
      icon: LuLayoutDashboard,
      link: "Dashboard",
      to: "/user-dashboard/",
    },
    {
      icon: HiOutlineRectangleStack,
      link: "Offers",
      to: "/user-dashboard/offers/received",
    },
    {
      icon: HiOutlineRectangleStack,
      link: "Tickets",
      to: "/user-dashboard/ticket",
    },
    {
      icon: MdOutlineLocalOffer,
      link: "Ads",
      to: "/user-dashboard/adds/active",
    },
    {
      icon: AiOutlineMessage,
      link: "Messages",
      to: "/user-dashboard/chat",
    },
    {
      type: "Main",
      icon: AiOutlineShop,
      link: "Marketplace",
      SubLink: [
        {
          link: "Services",
          icon: MdDesignServices,
          to: "/user-dashboard/service/",
        },
        {
          link: "Marketplace",
          icon: FaProductHunt,
          to: "/user-dashboard/marketplace/",
        },
      ],
    },
    {
      icon: MdOutlineHistory,
      link: "Billing history",
      to: "/user-dashboard/billing_history",
    },
  ];